import { Chapter } from '../../models/chapter';

export class ChapterChangedEvent {

    previousChapter;
    chapter: Chapter;
    nextChapter: Chapter;
}
